import I18n from 'I18n';
// @ts-ignore svg import
import FeatureIcon from 'bender-url!pricing-pages-ui-components/js/hsocImages/credits_explainer_sparkle.svg';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Image } from 'foundations-components/transitional/components/Image';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import styled from 'foundations-theming/utils';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BoldSpan = styled.span.withConfig({
  displayName: "CreditsExplainerFeatureCard__BoldSpan"
})({
  fontWeight: 700
});
const Bold = ({
  children
}) => /*#__PURE__*/_jsx(BoldSpan, {
  children: children
});
const getFeatureContent = type => {
  if (type === 'simple') {
    return {
      title: I18n.text('hsocCreditsExplainer.features.simple.title'),
      bullets: [/*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "hsocCreditsExplainer.features.simple.bullets.onlyPayWhenWorkGetsDone_jsx",
        elements: {
          Bold
        }
      }, "onlyPay"), /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "hsocCreditsExplainer.features.simple.bullets.clearView_jsx",
        elements: {
          Bold
        }
      }, "clearView")]
    };
  }
  return {
    title: I18n.text('hsocCreditsExplainer.features.flexible.title'),
    bullets: [/*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "hsocCreditsExplainer.features.flexible.bullets.buyUpFront_jsx",
      elements: {
        Bold
      }
    }, "buyUpFront"), /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "hsocCreditsExplainer.features.flexible.bullets.setBudget_jsx",
      elements: {
        Bold
      }
    }, "setBudget")]
  };
};
const CreditsExplainerFeatureCard = ({
  type
}) => {
  const content = getFeatureContent(type);
  return /*#__PURE__*/_jsxs(View, {
    flex: 1,
    children: [/*#__PURE__*/_jsxs(Flex, {
      flexDirection: "row",
      alignItems: "center",
      gap: "200",
      children: [/*#__PURE__*/_jsx(View, {
        minInlineSize: "28px",
        maxInlineSize: "28px",
        children: /*#__PURE__*/_jsx(Image, {
          src: FeatureIcon,
          alt: ""
        })
      }), /*#__PURE__*/_jsx(Text, {
        as: "h3",
        "data-typography": "h4",
        typography: "heading-400",
        "data-style": "text-white",
        color: "text-primary-default",
        children: content.title
      })]
    }), /*#__PURE__*/_jsx(Text, {
      color: "text-primary-default",
      "data-style": "text-white",
      as: "div",
      children: /*#__PURE__*/_jsx(List, {
        styled: true,
        marginBlockStart: "300",
        paddingInlineStart: "600",
        children: content.bullets.map((bullet, index) => /*#__PURE__*/_jsx(ListItem, {
          children: /*#__PURE__*/_jsx(Text, {
            as: "p",
            "data-typography": "p-sm",
            marginBlockStart: "300",
            children: bullet
          })
        }, index))
      })
    })]
  });
};
export default CreditsExplainerFeatureCard;